import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { BucketDataModel } from "common/models/page-models/applicants/bucket/bucket-data.model";
import { BucketGridParams, BucketListingModel, BucketModel } from "common/models/page-models/applicants/bucket/bucket-grid.model";
import { GridPostParams } from "common/models/utility-models/list-utility.model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { GridDataService } from "../../base-data-services/grid-data.service";

@Injectable({
    providedIn: 'root',
  })
  export class BucketDataService extends GridDataService<BucketListingModel, BucketModel> {
   
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.bucketList, http, ss);
    }

    createInstance(): BucketListingModel {
        // const previewDetails=JSON.parse(sessionStorage.getItem('previeDetails'));
        // console.log(previewDetails)
        // return previewDetails;
        return new BucketListingModel();
    }

    override transformDataModel(data: any, param) {
    
        return data;
    }
   
    override getGridParams(param): GridPostParams {
        const params = new BucketGridParams();
        // console.log(params)
        return params;
      }
    

    override getDeleteUrl(): string {
        return '';
    }
    
  }